export enum EAgentBankQueryKey {
  GET = 'get-agent-bank',
  CREATE = 'create-agent-bank',
  UPDATE = 'update-agent-bank',
  DELETE = 'delete-agent-bank',
  SET_DEFAULT = 'set-default-agent-bank',
}
